module.exports = __webpack_public_path__ + "static/img/Report3DCoverlen.21ba8de0.png";